import { render, staticRenderFns } from "./questionPromot.vue?vue&type=template&id=5f4a0eb4&scoped=true"
import script from "./questionPromot.vue?vue&type=script&lang=js"
export * from "./questionPromot.vue?vue&type=script&lang=js"
import style0 from "./questionPromot.vue?vue&type=style&index=0&id=5f4a0eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a0eb4",
  null
  
)

export default component.exports